import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../../Containers/Config/index.js';
import { CREATE_EVENT_RULE, CREATE_EVENT_RULE_SUCCESS, CREATE_EVENT_RULE_ERROR } from '../../../actionType';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* createEventRule({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/event-rules`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(`Event rule created successfully`);
      yield put({
        type: CREATE_EVENT_RULE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CREATE_EVENT_RULE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_EVENT_RULE_ERROR, payload: error });
  }
}

export function* watchCreateEventRule() {
  yield takeEvery(CREATE_EVENT_RULE, createEventRule);
}

function* createEventRuleSaga() {
  yield all([fork(watchCreateEventRule)]);
}

export default createEventRuleSaga;
